import React, { useState } from 'react';
import { AdminHeader } from './components/AdminHeader';
import { CreateNoticeForm } from './components/CreateNoticeForm';
import { Sidebar } from './components/Sidebar';
import { RequetesModule } from './components/RequetesModule';
import { PermisModule } from './components/PermisModule';
import { LoisirsModule } from './components/LoisirsModule';
import { BcitiIdModule } from './components/BcitiIdModule';
import { BcitiCollectesModule } from './components/BcitiCollectesModule';
import { BcitiCompteursModule } from './components/BcitiCompteursModule';
import { AtnaModule } from './components/AtnaModule';
import { SettingsModule } from './components/SettingsModule';
import { ReleaseNotesModule } from './components/ReleaseNotesModule';
import { useScreenInit } from './useScreenInit.js';
import { LanguageProvider } from './contexts/LanguageContext';
import { CityProvider } from './contexts/CityContext';
import { AccountProvider } from './contexts/AccountContext';
import { EmailIdentityProvider } from './contexts/EmailIdentityContext';
import type { FeatureTarget } from './utils/releaseTryTarget';
export function App() {
  const screenInit = useScreenInit();
  const [activeTab, setActiveTab] = useState(screenInit.activeTab ?? 'requetes');
  /** Set when a release note's "Essayer" button opens a specific spot. */
  const [target, setTarget] = useState<FeatureTarget | null>(null);
  /** Bumped on every "Essayer" so the target module remounts on the right sub-tab. */
  const [navKey, setNavKey] = useState(0);
  const changeTab = (tab: string) => {
    setTarget(null);
    setActiveTab(tab);
  };
  const tryFeature = (next: FeatureTarget) => {
    setTarget(next);
    setNavKey(k => k + 1);
    setActiveTab(next.tab);
  };
  return <LanguageProvider data-id="element-0" data-mp="3dm5ze27p6oic">
      <CityProvider data-id="element-1" data-mp="nvj4pj9gikrb">
      <AccountProvider data-id="element-2" data-mp="nw2a60hx7gog">
      <EmailIdentityProvider data-id="element-3" data-mp="nuhicimzqbua">
      <div className="min-h-screen bg-[#F8FAFC] font-body text-slate-900 flex flex-col h-screen" data-id="element-4" data-mp="nvaszup2llhp">
        <AdminHeader data-id="element-5" data-mp="ssss6tdacmci" />
        <div className="flex flex-1 overflow-hidden" data-id="element-6" data-mp="36hwt7ylgu1r">
          <Sidebar activeTab={activeTab} onTabChange={changeTab} data-id="element-7" data-mp="356r32ll9c80" />
          <main className="flex-1 overflow-y-auto" data-id="element-8" data-mp="3uday0bte0t6a">
            {activeTab === 'requetes' ? <RequetesModule key={navKey} initialSubTab={target?.subTab} data-id="element-9" data-mp="d57hf8hvkslp" /> : activeTab === 'permis' ? <PermisModule data-id="element-10" data-mp="86meh1b8nutk" /> : activeTab === 'bciti-id' ? <BcitiIdModule data-id="element-11" data-mp="3gl4pnbwh7qhe" /> : activeTab === 'loisirs' ? <LoisirsModule data-id="element-12" data-mp="3gj1r23h9cp12" /> : activeTab === 'collectes' ? <BcitiCollectesModule data-id="element-13" data-mp="3bo4n3ayu55v1" /> : activeTab === 'compteurs' ? <BcitiCompteursModule data-id="element-14" data-mp="3qbzfeq8xl87l" /> : activeTab === 'atna' ? <AtnaModule data-id="element-15" data-mp="3lk7k62etyeb4" /> : activeTab === 'release-notes' ? <ReleaseNotesModule onTryFeature={tryFeature} data-id="element-16" data-mp="2xun3jq65ft50" /> : activeTab === 'settings' ? <SettingsModule data-id="element-17" data-mp="2swbuhhnohmnu" /> : <CreateNoticeForm key={navKey} initialSubTab={target?.subTab} initialView={target?.view} data-id="element-18" data-mp="2svjxc2efngvg" />}
          </main>
        </div>
      </div>
      </EmailIdentityProvider>
      </AccountProvider>
      </CityProvider>
    </LanguageProvider>;
}